import { FC } from 'react';
import { Client } from '../../../List/models/Clients';
import { DropdownActions } from '../interaction/DropdownActions';

interface HeaderButtonsProps {
    client: Client | undefined;
    onImpersonate?: (userId: number) => void;
}

export const HeaderButtons: FC<HeaderButtonsProps> = ({
    client,
    onImpersonate
}) => {
    return (
        <div className="flex justify-end gap-2 absolute top-2 right-6">
            <DropdownActions client={client} onImpersonate={onImpersonate} />
        </div>
    );
};

